import React from "react";

export default function Subscription() {
  return (
    <div className="flex">
      <h1 className="text-[#1F4B7F] text-[2vw] flex items-center justify-center">
        Subscription
      </h1>
    </div>
  );
}
